import React, { useState } from 'react';
import ModalComponent from '@components/Modal/ModalComponent';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { Card, CardBody } from '@components/card/card';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';

import AddBankAccounts from './Add';

import UpdateBankAccounts from './Update';
import { Link } from 'react-router-dom';
import useGetBankAccountsList from '@hooks/Finance/BankAccounts/useGetBankAccountsList';
import Loading from '@components/Shared/Loader/Loading';
import useGetBanks from '@hooks/Lookups/use-get-Banks';
import NtxTable from '@components/DataTable/NtxTable';

const Index = () => {
  const [ID, setID] = useState<string>('');

  const [Show, setShow] = useState(false);
  const [search, setSearch] = useState('');
  const [selectedBank, setSelectedBank] = useState<any>(null);

  const { t, i18n } = useTranslation();
  const { BanksOptions, loading: loading2, error: error2 } = useGetBanks();
  const { BankAccountsList, loading, error } = useGetBankAccountsList();

  const filteredSearch = BankAccountsList?.slice()?.filter(item => {
    const searchLowerCase = search.toLowerCase();
    const matchesSearch =
      item.name?.toLowerCase().includes(searchLowerCase) || item.name2?.toLowerCase().includes(searchLowerCase);

    const matchesBank = selectedBank ? item.ntxBankId === selectedBank : true;

    return matchesSearch && matchesBank;
  });

  const columns = [
    { title: t('Name'), key: 'name' },
    { title: t('NameBank'), key: 'NameBank' },
    { title: t('NoBank'), key: 'NoBank' },
    { title: t('Iban'), key: 'Iban' },
    { title: t('وحدة التشغيل'), key: 'organizationName' },
    { title: t('الحسـاب المالي'), key: 'financialAccount' },

    { title: '', key: 'action', className: 'text-end' }
  ];

  const tableData =
    filteredSearch?.map(item => {
      let rowClass;

      return {
        name: i18n.language === 'en' ? item.name : item.name2,
        NameBank: i18n.language === 'en' ? item.ntxBankName : item.ntxBankName2,
        financialAccount: i18n.language === 'en' ? item.accountName : item.accountName2,
        NoBank: item.bankAccount,
        Iban: item.iban,
        organizationName: i18n.language === 'en' ? item.organizationName : item.organizationName2,

        action: (
          <>
            <button
              type='button'
              className='btn btn-sm btn-outline-theme ms-1'
              data-bs-toggle='modal'
              data-bs-target='#modalEdit'
              onClick={() => setID(item.id)}
            >
              <i className='far fa-lg fa-fw fa-edit me-1'></i>
              {t('Button.Edit')}
            </button>
          </>
        )
      };
    }) || [];

  //____________________________

  return (
    <div>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
              link: ':moduleHome'
            },
            {
              name: 'BankAccounts',
              link: null
            }
          ]}
          PageName='BankAccounts'
        />

        <div className='ms-auto'>
          <Link
            to=''
            className='btn me-1 btn-theme'
            data-bs-toggle='modal'
            data-bs-target='#modalAddDailyRates'
            onClick={() => setShow(true)}
          >
            <i className='fa fa-plus-circle fa-fw me-1'></i>
            {t('NewBankAccount')}
          </Link>
        </div>
      </div>

      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <div className='row mb-2'>
              <div className='col-lg-6'>
                <div className='input-group flex-nowrap'>
                  <span className='input-group-text fw-bold'>{t('Search')}</span>
                  <div className='input-group'>
                    <div className='flex-fill position-relative'>
                      <div className='input-group border-0 '>
                        <div className='input-group-text position-absolute top-0 bottom-0 bg-none border-0 pe-0'>
                          <i className='fa fa-search opacity-5 text-theme'></i>
                        </div>
                        <input
                          type='text'
                          autoComplete='off'
                          className='form-control ps-35px'
                          // placeholder={t('Search')}
                          value={search}
                          onChange={e => {
                            setSearch(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-lg-6'>
                <div className='input-group flex-nowrap'>
                  <span className='input-group-text  fw-bold'>{t('Bank')}</span>
                  <Select
                    classNamePrefix='react-select'
                    className={`w-100 `}
                    isLoading={loading2}
                    isSearchable={true}
                    isClearable
                    options={BanksOptions}
                    onChange={(option: any) => {
                      setSelectedBank(option?.value);
                    }}
                    placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                  />
                </div>
              </div>
            </div>

            <NtxTable
              data={tableData || []}
              columns={columns || []}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              // enableSearch={true}
              // showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      <ModalComponent title={t('AddBankAccount')} id='modalAddDailyRates' size='lg'>
        {Show && <AddBankAccounts />}
      </ModalComponent>

      <ModalComponent title={t('EditBankAccount')} id='modalEdit' size='lg'>
        {ID && <UpdateBankAccounts ID={ID} />}
      </ModalComponent>
    </div>
  );
};

export default Index;
